"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var react_1 = __importDefault(require("react"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var ej2_react_grids_1 = require("@syncfusion/ej2-react-grids");
require("@syncfusion/ej2/tailwind.css");
require("@syncfusion/ej2-base/styles/tailwind.css");
require("@syncfusion/ej2-react-grids/styles/tailwind.css");
var numberFormatter = new Intl.NumberFormat('en-AU');
function formatDate(value) {
    if (!value) {
        return 'Not sent';
    }
    var parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return value;
    }
    return new Intl.DateTimeFormat('en-AU').format(parsed);
}
function DashboardPointsSent(_a) {
    var rows = _a.rows;
    var route = (0, useRoute_1.default)();
    var gridExtras = {
        loadingIndicator: { indicatorType: 'Spinner' },
        emptyRecordTemplate: function () { return (react_1.default.createElement("span", { className: "text-gray-500" }, "No sent points found.")); },
    };
    return (react_1.default.createElement(AppLayout_1.default, { title: "Points Sent on Date", renderHeader: function () { return (react_1.default.createElement("div", { className: "flex items-center justify-between" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "text-xs uppercase tracking-[0.3em] text-gray-400" }, "Segment"),
                react_1.default.createElement("h2", { className: "text-2xl font-semibold text-gray-900" }, "Points Sent on Date"),
                react_1.default.createElement("p", { className: "text-sm text-gray-500" }, "Points issued by sent date")),
            react_1.default.createElement(inertia_react_1.InertiaLink, { href: route('dashboard.metrics'), className: "text-sm text-blue-600 hover:text-blue-700" }, "Back to Metrics"))); } },
        react_1.default.createElement("div", { className: "py-10" },
            react_1.default.createElement("div", { className: "mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" },
                react_1.default.createElement("div", { className: "rounded-2xl bg-white p-4 shadow-sm" },
                    react_1.default.createElement(ej2_react_grids_1.GridComponent, __assign({ id: "dashboard-points-sent", dataSource: rows }, gridExtras, { allowPaging: true, allowSorting: true, allowFiltering: true, pageSettings: { pageSize: 20 }, sortSettings: { columns: [{ field: 'sent_date', direction: 'Descending' }] } }),
                        react_1.default.createElement(ej2_react_grids_1.ColumnsDirective, null,
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "sent_date", headerText: "Sent Date", width: "170", template: function (props) { return (react_1.default.createElement("span", null, formatDate(props.sent_date))); } }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "points_total", headerText: "Points", textAlign: "Right", format: "N0", width: "140" }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "rewards_count", headerText: "Rewards", textAlign: "Right", format: "N0", width: "120" })),
                        react_1.default.createElement(ej2_react_grids_1.Inject, { services: [ej2_react_grids_1.Toolbar, ej2_react_grids_1.Sort, ej2_react_grids_1.Filter] })),
                    rows.length > 0 && (react_1.default.createElement("p", { className: "mt-3 text-xs text-gray-400" },
                        numberFormatter.format(rows.length),
                        " sent dates shown")))))));
}
exports.default = DashboardPointsSent;
